import {
  ComponentStateManager,
  DataVizContainerCommonUtils,
} from '../../../common/types';
import { getBarChartDataFromOverTimeSegmentedResponse } from '../../over-time-segmented-utils';
import {
  OverTimeSegmentedVizData,
  OverTimeSegmentedVizExternalProps,
} from '../../types';
import {
  OverTimeSegmentedBarChartActions,
  OverTimeSegmentedBarChartState,
  OverTimeSegmentedBarChartUiComponentProps,
} from './types';

export const overTimeSegmentedBarChartDataToUiComponentProps = (
  data: OverTimeSegmentedVizData,
  externalProps: OverTimeSegmentedVizExternalProps,
  componentStateManager: ComponentStateManager<
    OverTimeSegmentedBarChartState,
    OverTimeSegmentedBarChartActions
  >,
  { t, dataFieldValueFormatter }: DataVizContainerCommonUtils
): OverTimeSegmentedBarChartUiComponentProps => {
  const { dataResponse, titleConfig, metricDetailsMap, showTotal } = data;
  const { preferences } = externalProps;

  const { metric } = dataResponse;
  const metricDetail = metricDetailsMap[metric.value];
  if (!metricDetail) {
    throw new Error(
      `Invalid state. Metric details undefined for metric: ${metric.value}`
    );
  }

  const hasBenchmark = dataResponse.data.first()?.datapoints.first()
    ?.datapoint.hasBenchmark;

  if (hasBenchmark) {
    throw new Error(
      'Bar chart view for overtime segmented queries does not support benchmark'
    );
  }
  const chartData = getBarChartDataFromOverTimeSegmentedResponse(
    dataResponse,
    metricDetail,
    preferences,
    t,
    dataFieldValueFormatter,
    showTotal
  );

  const displayConfig = {
    ...componentStateManager.state.displayState,
    ...componentStateManager.actions.displayActions,
  };

  return {
    fullScreenHandle: externalProps.fullScreenHandle,
    displayConfig,
    titleConfig,
    chartData,
    chartColors: data.chartColors,
  };
};
